<template>

  <div class="card">
    <div class="card-header">
      {{ jobBoard.name }}
    </div>
    <div class="card-body">
      <img
        :src="jobBoard.logo_url"
        style="max-width: 200px"
        class="mb-2">

      <p>{{ jobBoard.description }}</p>

      <!-- Não integrado: exibe mensagem e não tem ações -->
      <div
        v-if="!jobBoard.integrated"
        class="alert alert-warning mb-0">
        {{ $t('To advertise on this board you need to set up the integration in Settings > Integrations.') }}
      </div>

      <!-- Publicação automática: sem ações -->
      <button
        v-else-if="jobBoard.fixed_published"
        type="button"
        class="btn btn-secondary disabled">{{ $t('Automatic') }}</button>

      <template v-else>
        <div
          v-if="posting && posting.status_sync === 'error'"
          class="alert alert-warning">
          {{ posting.error ? posting.error.message : null }}
        </div>

        <JobAdvertiseBoardsItemForm
          v-if="showOptionsJobBoard"
          :title="jobBoard.name"
          :fieldSchema="jobBoard.extra_field_schema"
          @cancel="showOptionsJobBoard = null"
          @save="setExtraFields"
          :validationErrors="validationErrors"
          :initParams="phase.extra_fields || {}"
          :loading="loading" />

        <div :class="{'box-loading': loading}">
          <template v-if="phase.status === 'unpublished'">
            <button
              type="button"
              @click="publish"
              class="btn btn-primary">{{ $t('Publish') }}</button>
          </template>
          <template v-else>
            <button
              v-if="hasExtraFields"
              type="button"
              @click="editExtraFields"
              class="btn btn-primary">{{ $t('Edit') }}</button>
            <button
              type="button"
              @click="unpublish"
              class="btn btn-secondary">{{ $t('Unpublish') }}</button>
          </template>
        </div>
      </template>

    </div>
  </div>

</template>

<script>
import JobAdvertiseBoardsItemForm from './JobAdvertiseBoardsItemForm'

export default {
  name: 'JobAdvertiseBoard',
  components: {
    JobAdvertiseBoardsItemForm
  },
  props: [
    'jobBoard'
  ],
  data () {
    return {
      loading: false,
      showOptionsJobBoard: false,
      validationErrors: null
    }
  },
  computed: {
    postings () {
      return this.$store.getters.getPostings
    },
    posting () {
      return this.postings.filter((p) => {
        return p.job_board === this.jobBoard.key
      })[0]
    },
    phase () {
      return this.posting ? this.posting.phase : { status: 'unpublished' }
    },
    hasExtraFields () {
      return Array.isArray(this.jobBoard.extra_field_schema) && this.jobBoard.extra_field_schema.length > 0
    },
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
    /*
    publish: se o board tem parâmetros, abre o formulário; senão publica direto
    */
    publish () {
      if (this.hasExtraFields) {
        this.showOptionsJobBoard = this.jobBoard.key
      } else {
        this.savePosting()
      }
    },
    /*
    editExtraFields: abre o formulário para editar os parâmetros de um posting existente
    */
    editExtraFields () {
      this.showOptionsJobBoard = this.jobBoard.key
    },
    /*
    setExtraFields: recebe os extra_fields do formulário e salva o posting
    */
    setExtraFields (extraFields) {
      this.savePosting(extraFields)
    },
    /*
    savePosting: cria (POST) quando o posting não existe, ou atualiza (PUT) quando existe.
    O status fica a cargo do backend (valor padrão).
    */
    async savePosting (extraFields) {
      this.loading = true

      try {
        if (this.posting && this.posting._id) {
          await this.$store.dispatch('updatePosting', {
            _id: this.posting._id,
            job_board: this.jobBoard.key,
            extra_fields: extraFields
          })
        } else {
          await this.$store.dispatch('createPosting', {
            job_id: this.job._id,
            job_board: this.jobBoard.key,
            extra_fields: extraFields
          })
        }
        await this.$store.dispatch('refreshSelectPostings')
        this.showOptionsJobBoard = false
      } catch (err) {
        const { name, errors } = err.response.data || {}
        if (name === 'ValidationError') {
          this.validationErrors = errors
        }
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    /*
    unpublish: despublica removendo o posting (DELETE)
    */
    unpublish () {
      this.loading = true

      this.$store
      .dispatch('deletePosting', {
        id: this.posting._id,
        job_board: this.jobBoard.key
      })
      .then((result) => {
        this.$store
        .dispatch('refreshSelectPostings')
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoardsItem.vue